import { useState } from 'react';

interface IState {
  lastUrl?: string;
}

export type UseLayout = {
  lastUrl?: string;
  setLastUrl: (url: string) => void;
};

export const useLayout = (): UseLayout => {
  const [state, setState] = useState<IState>({});

  return {
    ...state,
    setLastUrl: (lastUrl) => setState((state) => ({ ...state, lastUrl })),
  };
};
